<div class="container">
  <div class="box">
    <h1 class="fs-1">Style Guide</h1>
    <span>by:</span>
    <img class="w-100" style="max-width: 700px" src="../../../../../../assets/medias/images/theme/logo-full-blue.webp" alt="" />
  </div>
</div>
